import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import homecook_logo from "../../assets/img/homecook_logo.png";
// import NewSearch from "./NewSearch";
import { SearchFilterOptionType } from "../../data/types";
// import { ReactComponent as Filter } from "../../icons/filter.svg";
// import { ReactComponent as User } from "../../icons/user.svg";
import { LoginModal, FilterModal, InviteModal } from "../../molecules/Mobile/AppModal";
import LogoutIcon from "@mui/icons-material/Logout";
import { useCompleteSignIn } from "../../hooks/authhooks";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";

import { ReactComponent as UserIcon } from "../../icons/user.svg";
import { ReactComponent as MyBusinessIcon } from '../../icons/MyBusinessIcon.svg';
import { ReactComponent as HeartIcon } from '../../icons/HeartIcon.svg';
import { ReactComponent as BecomeAPartnerIcon } from '../../icons/BecomeAPartnerIcon.svg';
// import { ReactComponent as HomeIcon } from '../../icons/HomeIcon.svg';
// import { ReactComponent as HomeIconFilled } from '../../icons/HomeIconFilled.svg';
import { ReactComponent as MyBookingsIcon } from '../../icons/MyBookingsIcon.svg';
import { ReactComponent as InviteIcon } from '../../icons/InviteIcon.svg';
import { ReactComponent as NavResourcesIcon } from '../../icons/NavResourcesIcon.svg';
import { ReactComponent as NavResourcesIconDark } from '../../icons/NavResourcesIconDark.svg';
import { ReactComponent as NavCommunitiesIcon } from '../../icons/NavCommunitiesIcon.svg';
// import { ReactComponent as NavCommunitiesIconDark } from '../../icons/NavCommunitiesIconDark.svg';
import NavbarSkeleton from "./NavbarSkeleton";
import { ReactComponent as WalletIcon } from "../../icons/WalletIcon.svg";

import { ReactComponent as NotificationIcon } from "../../icons/Notification.svg";
// import { ReactComponent as ClickedNotificationIcon } from "../../icons/ClickedNotificationIcon.svg";
import { ReactComponent as CartIcon } from "../../icons/CartIcon.svg";
import { ReactComponent as ClickedCartIcon } from "../../icons/CartIconFilled.svg";
import { ReactComponent as FeedIcon } from '../../icons/FeedIcon.svg';
import { ReactComponent as ClickedFeedIcon } from '../../icons/FilledFeedIcon.svg'; 

import UserAvatar from "./UserAvatar";
// import { capitalizeString } from "../../utils/helpers";
import NoEmailBanner from "../../routers/NoEmailBanner";
import config from "../../config";

const profileMenuList = [
  {
    name: "profile",
    label: "My Profile",
    Icon: UserIcon,
    color: "#000000",
    badgeCount: null,
  },
  {
    name: "business",
    label: "My Business",
    Icon: MyBusinessIcon,
    color: "#000000",
    badgeCount: null,
  },
  {
    name: "saved",
    label: "Saved Resources",
    Icon: HeartIcon,
    color: "#000000",
    badgeCount: null, // Will be set dynamically
  },
  {
    name: "bookings",
    label: "Booking Details",
    Icon: MyBookingsIcon,
    color: "#000000",
    badgeCount: null, // Will be set dynamically
  },
  {
    name: "wallet",
    label: "Wallet",
    Icon: WalletIcon,
    color: "#000000",
    badgeCount: null,
  },
  {
    name: "invite",
    label: "Invite a Friend",
    Icon: InviteIcon,
    color: "#000000",
    badgeCount: null,
  },
  {
    name: "partner",
    label: "Become a Partner",
    Icon: BecomeAPartnerIcon,
    color: "#000000",
  },
  {
    name: "logout",
    label: "Logout",
    Icon: LogoutIcon,
    color: "#D42620",
    badgeCount: null,
  },
];

type NavbarProps = {
  searchFilterOptions: SearchFilterOptionType;
  loading: boolean;
};

const Navbar: React.FC<NavbarProps> = (props) => {
  const navigate = useNavigate();

  const { user } = useCompleteSignIn();
  const loggedinUsername = user && user?.username ? user.username : "";
  const loggedinUid = user && user?.uid ? user.uid : "";
  const { searchFilterOptions, loading } = props;
  const {
    currentFilter,
    // searchTerm,
    signInModalIsOpen,
    setCurrentFilter,
    // changeSearchTerm,
    setSignInModalIsOpen,
  } = searchFilterOptions;
  const [filterSetting, setFilterSetting] = useState<boolean>(false);
  const [userOptions, toggleUserOptions] = useState<boolean>(false);
  // const [notificationClicked, setNotificationClicked] = useState(false);
  const [inviteModalIsOpen, setInviteModalIsOpen] = useState(false);
  // const [feedClicked, setFeedClicked] = useState(false);
  // const [showCart, setShowCart] = useState(false);
  // const [cartClicked, setCartClicked] = useState(false);
  const [isBeta, setIsBeta] = useState(false);
  // const [width, setWidth] = useState(window.innerWidth);
  const location = useLocation()
  const currentLocation = location.pathname

  // function handleWindowSizeChange() {
  //   setWidth(window.innerWidth);
  // }

  useEffect(() => {
    const checkBetaInURL = () => {
        const currentURL = window.location.href.toLowerCase();
        return currentURL.includes('beta') || currentURL.includes('localhost') || currentURL.includes('homecook.space');
    };
    setIsBeta(checkBetaInURL());
    // window.addEventListener("resize", handleWindowSizeChange);
    // return () => {
    //   window.removeEventListener("resize", handleWindowSizeChange);
    // };
  }, []);

  // const isMobile = width <= 425;
  const notifications: any[] = []
  const cart: any[] = []
  const notificationCount = notifications.length;
  const cartCount = cart.length;

  // const toggleFilterSetting = () => {
  //   setFilterSetting((prev) => !prev);
  // };

  // const toggleNotifications = () => {
  //   setNotificationClicked((prev) => !prev);
  // };

  // const goToFeed = () => {
  //   navigate(`/feed`)
  // };

  // const goToCart = () => {
  //   navigate(`/cart`)
  // };


  return (
    <>
    {/* <div className="flex flex-col justify-center bg-primaryLight-1000 fixed w-full z-30 h-[182px]  font-open-sans cursor-pointer border-b-2"> */}
        <div className="flex flex-col  bg-primaryLight-1000  w-full z-10  font-open-sans cursor-pointer items-baseline place-items-baseline justify-center border-b-2 h-[90px] align-baseline ">
            <div className="flex flex-row items-center w-11/12 sm:w-full m-auto justify-between ">
              <div className="flex flex-row   w-[168px] h-[62px] justify-between ">
                <img
                  src={homecook_logo}
                  alt="Kitchen Logo"
                  className="w-22 h-12 my-auto cursor-pointer"
                  onClick={() => navigate("/")}
                />
                <div
                  className="flex flex-row text-primaryDark-0 text-xl mr-auto my-auto font-bold cursor-pointer"
                  onClick={() => navigate("/")}
                >
                  HomeCook

                  {/* Add Beta Tag */}
                  {
                    (isBeta) && (
                      <div className="flex items-center gap-1 bg-gradient-to-r from-primaryDark-400 to-primaryDark-300 text-white px-2 py-0.5 rounded-full shadow-md my-auto ml-2 mr-autoleft-0 scale-90">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                              <path d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" />
                          </svg>
                          <span className="font-medium text-xs tracking-wide font-open-sans">BETA</span>
                      </div>
                    )
                  }
                </div>
              </div>
              {loggedinUid ? (
                <>
                  <div className="text-xs flex flex-row ml-auto text-black w-auto m-4 h-6 my-auto items-center ">
                    {user && user?.avatar ? (
                      <div className="flex border-[#E9E9E9] border-[1px] rounded-full h-9 w-9 mr-2 cursor-pointer" onClick={() => toggleUserOptions(true)}>
                        <img
                          id="image-input-avatar"
                          src={user.avatar}
                          alt="User Avatar"
                          className="h-8 w-8  m-auto rounded-full"
                          onError={(e) => { e.currentTarget.style.display = 'none'; }}
                        />
                      </div>
                    ) : (
                      <div onClick={() => toggleUserOptions(true)} className="cursor-pointer">
                        <UserAvatar
                          firstName={user?.first_name}
                          lastName={user?.last_name}
                          username={user?.username}
                          email={user?.email}
                          size="md"
                          className="mr-2"
                        />
                      </div>
                    )}
                    <div className="flex flex-col cursor-pointer" onClick={() => toggleUserOptions(true)}>
                      <p className="text-black hidden sm:block">
                        Hi, {user && user?.first_name ? user.first_name : ""}
                      </p>
                      <p className="my-auto  text-[#4D4D4D] hidden sm:block mr-2">
                        {loggedinUsername}
                      </p>
                    </div>
        
                    {userOptions ? (
                      <KeyboardArrowUpIcon
                        className="text-black hover:text-primaryDark-300 cursor-pointer"
                        onClick={() => toggleUserOptions(false)}
                      />
                    ) : (
                      <KeyboardArrowDownIcon
                        className="text-black hover:text-primaryDark-300 cursor-pointer"
                        onClick={() => toggleUserOptions(true)}
                      />
                    )}
        
                    {userOptions && (
                      <ProfileMenuModal
                        isOpen={userOptions}
                        onClose={() => toggleUserOptions(false)}
                        inviteModalIsOpen={inviteModalIsOpen}
                        setInviteModalIsOpen={setInviteModalIsOpen}
                        currentLocation={currentLocation}
                        loading={loading}
                        user={user}
                        notificationCount={notificationCount}
                        cartCount={cartCount}
                      />
                    )}
                  </div>
                </>
              ) : (
                <>
                  <button
                    onClick={() => toggleUserOptions(true)}
                    className="bg-transparent h-10 w-10 flex items-center justify-center border-0 cursor-pointer ml-auto rounded-lg hover:bg-[#F0F0F0] transition-colors"
                    aria-label="Open menu"
                  >
                    <MenuIcon className="text-[#1A1A1A] h-6 w-6" />
                  </button>
                  {userOptions && (
                    <ProfileMenuModal
                      isOpen={userOptions}
                      onClose={() => toggleUserOptions(false)}
                      inviteModalIsOpen={inviteModalIsOpen}
                      setInviteModalIsOpen={setInviteModalIsOpen}
                      currentLocation={currentLocation}
                      loading={loading}
                      user={null}
                      notificationCount={0}
                      cartCount={0}
                      onSignInClick={() => {
                        toggleUserOptions(false);
                        setSignInModalIsOpen(true);
                      }}
                    />
                  )}
                </>
              )}
            </div>
            
          </div>
          {/* <div className="flex flex-row justify-center w-full gap-2">
              <NewSearch
                searchTerm={searchTerm}
                toggleFilterSetting={toggleFilterSetting}
                filterSetting={filterSetting}
                changeSearchTerm={changeSearchTerm}
                searchType={"resources"}
              />
              <div
                onClick={() => setFilterSetting(true)}
                className={`border-2 rounded-2xl w-10 h-10 flex items-center place-self-center hover:cursor-pointer ${
                  filterSetting
                    ? "bg-primaryDark-200 text-white "
                    : "bg-primaryLIght-1000 text-black"
                } `}
              >
              </div>
          </div> */}
          {" "}
    {/* </div> */}

        <LoginModal
          isOpen={signInModalIsOpen}
          setIsOpen={setSignInModalIsOpen}
          closeAppModal={() => {
            setSignInModalIsOpen(false);
          }}
        />
        <FilterModal
          isOpen={filterSetting}
          setIsOpen={setFilterSetting}
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
          closeAppModal={() => setFilterSetting(false)}
        />

        <InviteModal
          uid={user?.uid || ""}
          isOpen={inviteModalIsOpen}
          setIsOpen={setInviteModalIsOpen}
          closeAppModal={() => {
            setInviteModalIsOpen(false);
          }}
        />
        
        {loggedinUid && !loggedinUsername && (
          <NoEmailBanner signInModalIsOpen={signInModalIsOpen} />
        )}
    </>
  );
};

type ProfileMenuModalProps = {
  isOpen: boolean;
  onClose: () => void;
  inviteModalIsOpen: boolean;
  setInviteModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  currentLocation: string;
  loading: boolean;
  user: any;
  notificationCount: number;
  cartCount: number;
  onSignInClick?: () => void;
};

const ProfileMenuModal: React.FC<ProfileMenuModalProps> = ({
  isOpen,
  onClose,
  inviteModalIsOpen,
  setInviteModalIsOpen,
  currentLocation,
  loading,
  user,
  notificationCount,
  cartCount,
  onSignInClick,
}) => {
  const navigate = useNavigate();
  const { signOut } = useCompleteSignIn();
  const isLoggedIn = !!user;

  // Mock counts - in production, these would come from API/hooks
  const savedResourcesCount = 0;
  const bookingsCount = 0;

  const handleMenuItemClick = (itemName: string) => {
    if (itemName === "logout") {
      signOut();
      navigate("/");
      onClose();
    } else if (itemName === "invite") {
      setInviteModalIsOpen(true);
      onClose();
    } else if (itemName === "partner") {
      window.open(config.dashboardUrl, '_blank');
      onClose();
    } else {
      navigate(`/${itemName}`);
      onClose();
    }
  };

  // Navigation items
  const navigationItems = [
    // {
    //   name: "home",
    //   label: "Home",
    //   Icon: HomeIcon,
    //   IconActive: HomeIconFilled,
    //   isActive: currentLocation === "/",
    //   onClick: () => { navigate("/"); onClose(); },
    // },
    {
      name: "resources",
      label: "Resources",
      Icon: NavResourcesIcon,
      IconActive: NavResourcesIconDark,
      isActive: ["/", "/resources", "/kitchen", "/documentation", "/training", "/funding", "/expert", "/farm"].includes(currentLocation),
      onClick: () => { navigate("/"); onClose(); },
    },
    {
      name: "communities",
      label: "Communities",
      Icon: NavCommunitiesIcon,
      IconActive: NavCommunitiesIcon,
      isActive: currentLocation === "/communities",
      onClick: () => { navigate("/communities"); onClose(); },
    },
    // {
    //   name: "feed",
    //   label: "Feed",
    //   Icon: FeedIcon,
    //   IconActive: ClickedFeedIcon,
    //   isActive: currentLocation === "/feed",
    //   onClick: () => { navigate("/feed"); onClose(); },
    // },
  ];

  // Helper function to check if a route is active
  const isRouteActive = (routeName: string): boolean => {
    switch (routeName) {
      case "profile":
        return currentLocation === "/profile" || 
               currentLocation.startsWith("/profile/");
      case "business":
        return currentLocation === "/business";
      case "saved":
        return currentLocation === "/saved";
      case "bookings":
        return currentLocation === "/bookings";
      case "wallet":
        return currentLocation === "/wallet";
      case "feed":
        return currentLocation === "/feed";
      case "cart":
        return currentLocation === "/cart";
      default:
        return false;
    }
  };

  // Update badge counts and add active state dynamically
  const menuItemsWithBadges = profileMenuList.map(item => {
    const updatedItem: any = { ...item };
    
    if (item.name === "saved") {
      updatedItem.badgeCount = savedResourcesCount;
    } else if (item.name === "bookings") {
      updatedItem.badgeCount = bookingsCount;
    }
    
    // Add active state
    updatedItem.isActive = isRouteActive(item.name);
    
    return updatedItem;
  });

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-[9999] flex items-start justify-end">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black/50 z-[9998]" 
          onClick={onClose}
        />
        
        {/* Sidebar */}
        <div 
          className="fixed right-0 top-0 h-full w-full sm:w-[400px] max-w-[400px] bg-white z-[9999] shadow-2xl flex flex-col overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-[#E9E9E9] bg-white">
            <div className="flex items-center gap-3">
              <img
                src={homecook_logo}
                alt="HomeCook Logo"
                className="w-10 h-10 cursor-pointer"
                onClick={() => { navigate("/"); onClose(); }}
              />
              <div className="flex flex-col">
                <p className="text-[#1A1A1A] font-bold text-lg font-raleway">HomeCook</p>
                {isLoggedIn && user && (
                  <p className="text-[#666] text-xs font-open-sans">
                    {user?.first_name ? `Hi, ${user.first_name}` : user?.username || user?.email}
                  </p>
                )}
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-8 h-8 flex border-0 items-center bg-[#F5F5F5] justify-center rounded-full hover:bg-[#F0F0F0] transition-colors"
              aria-label="Close menu"
            >
              <CloseIcon className="text-[#A1A1A1] h-5 w-5" />
            </button>
          </div>

          {/* Scrollable Content */}
          <div className="flex-1 overflow-y-auto">
            {/* Navigation Links */}
            <div className="px-4 py-4 border-b border-[#E9E9E9]">
              {loading ? (
                <div className="px-2">
                  <NavbarSkeleton />
                </div>
              ) : (
                <div className="space-y-1">
                  {navigationItems.map((item) => {
                    const IconComponent = item.isActive ? item.IconActive : item.Icon;
                    return (
                      <button
                        key={item.name}
                        onClick={item.onClick}
                        className={`w-full flex border-0 items-center gap-3 px-3 py-3 rounded-lg transition-colors ${
                          item.isActive
                            ? "bg-[#E6EBED]/50 text-[#013847]"
                            : "text-[#808080] hover:bg-[#F8F8F8]"
                        }`}
                      >
                        <IconComponent className={`h-5 w-5 ${item.isActive ? "text-[#013847]" : "text-[#A1A1A1]"}`} />
                        <span className={`font-raleway text-sm font-medium ${item.isActive ? "text-[#013847]" : "text-[#808080]"}`}>
                          {item.label}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Notifications and Cart - Only for logged in users */}
            {isLoggedIn && (
              <div className="px-4 py-3 border-b border-[#E9E9E9]">
                <div className="space-y-1">
                  <button
                    onClick={() => {
                      navigate("/feed");
                      onClose();
                    }}
                    className={`w-full flex border-0 items-center justify-between px-3 py-3 rounded-lg transition-colors ${
                      isRouteActive("feed")
                        ? "bg-[#E6EBED]/50 text-[#013847]"
                        : "text-[#808080] hover:bg-[#F8F8F8]"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {isRouteActive("feed") ? (
                        <ClickedFeedIcon className="h-5 w-5 text-[#013847]" />
                      ) : (
                        <FeedIcon className="h-5 w-5 text-[#A1A1A1]" />
                      )}
                      <span className={`font-raleway text-sm font-medium ${isRouteActive("feed") ? "text-[#013847]" : "text-[#808080]"}`}>
                        Feed
                      </span>
                    </div>
                  </button>
                  <button
                    onClick={() => {
                      // Navigate to notifications (if route exists)
                      onClose();
                    }}
                    className="w-full flex border-0 items-center justify-between px-3 py-3 rounded-lg transition-colors text-[#808080] hover:bg-[#F8F8F8]"
                  >
                    <div className="flex items-center gap-3">
                      <NotificationIcon className="h-5 w-5 text-[#A1A1A1]" />
                      <span className="font-raleway text-sm font-medium text-[#808080]">Notifications</span>
                    </div>
                    {notificationCount > 0 && (
                      <div className="flex items-center justify-center min-w-[24px] h-6 px-1.5 bg-[#013847] text-white text-xs font-bold rounded-full">
                        {notificationCount}
                      </div>
                    )}
                  </button>
                  <button
                    onClick={() => {
                      navigate("/cart");
                      onClose();
                    }}
                    className={`w-full flex border-0 items-center justify-between px-3 py-3 rounded-lg transition-colors ${
                      isRouteActive("cart")
                        ? "bg-[#E6EBED]/50 text-[#013847]"
                        : "text-[#808080] hover:bg-[#F8F8F8]"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {isRouteActive("cart") ? (
                        <ClickedCartIcon className="h-5 w-5 text-[#013847]" />
                      ) : (
                        <CartIcon className="h-5 w-5 text-[#A1A1A1]" />
                      )}
                      <span className={`font-raleway text-sm font-medium ${isRouteActive("cart") ? "text-[#013847]" : "text-[#808080]"}`}>
                        Cart
                      </span>
                    </div>
                    {cartCount > 0 && (
                      <div className="flex items-center justify-center min-w-[24px] h-6 px-1.5 bg-[#013847] text-white text-xs font-bold rounded-full">
                        {cartCount}
                      </div>
                    )}
                  </button>
                </div>
              </div>
            )}

            {/* Profile Menu Items - Only for logged in users */}
            {isLoggedIn && (
              <div className="px-4 py-3">
                <div className="space-y-1">
                  {menuItemsWithBadges.map((item, i) => {
                    const isLogout = item.name === "logout";
                    const isActive = item.isActive && !isLogout;
                    return (
                      <button
                        key={i}
                        onClick={() => handleMenuItemClick(item.name)}
                        className={`w-full flex items-center justify-between px-3 py-3 border-0 rounded-lg transition-colors ${
                          isLogout
                            ? "text-[#D42620] hover:bg-red-50"
                            : isActive
                            ? "bg-[#E6EBED]/50 text-[#013847]"
                            : "text-[#808080] hover:bg-[#F8F8F8]"
                        }`}
                      >
                        <div className="flex items-center gap-3">
                          <div className={
                            isLogout 
                              ? "text-[#D42620]" 
                              : isActive 
                              ? "text-[#013847]" 
                              : "text-[#A1A1A1]"
                          }>
                            <item.Icon className="h-5 w-5" />
                          </div>
                          <span className={`font-raleway text-sm font-medium ${
                            isLogout 
                              ? "text-[#D42620]" 
                              : isActive 
                              ? "text-[#013847]" 
                              : "text-[#808080]"
                          }`}>
                            {item.label}
                          </span>
                        </div>
                        {item.badgeCount !== null && item.badgeCount > 0 && (
                          <div className="flex items-center justify-center min-w-[24px] h-6 px-1.5 bg-[#013847] text-white text-xs font-bold rounded-full">
                            {item.badgeCount}
                          </div>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Sign In Button - Only for logged out users */}
            {!isLoggedIn && onSignInClick && (
              <div className="px-4 py-4">
                <button
                  onClick={onSignInClick}
                  className="w-full bg-[#013847] text-white py-3 rounded-lg font-semibold text-sm hover:bg-[#012a35] transition-colors font-raleway"
                >
                  Sign In
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;



